
import { Component, Emit, Prop, Provide, ProvideReactive, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class Select extends Vue {
  @Prop() name?: string;
  @Prop({ default: '' }) value!: string;
  @ProvideReactive('selectedValue') selectedValue = '';
  @Emit('onChange')
  onChange(value: string) {}

  @Watch('value')
  onPropChange() {
    this.selectedValue = this.value;
  }

  onSelectionChange(event: any) {
    this.onChange(event.target.value as string);
  }
}
